import Box from "@amzn/awsui-components-console/box";
import Button from "@amzn/awsui-components-console/button";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';

const PRESIGNED_MARKERS = [".s3.", "X-Amz-Signature"] as const;

export function isPresignedS3Url(href?: string): boolean {
    if (!href || !/^https?:\/\//i.test(href)) return false;
    return PRESIGNED_MARKERS.every((m) => href.includes(m));
}

interface MarkdownLinkProps {
    href?: string;
    children?: React.ReactNode;
}

export const MarkdownLink = ({ href, children }: MarkdownLinkProps) => {
    if (isPresignedS3Url(href)) {
        const label = typeof children === "string" ? children : getString('chatbot.export.downloadFallbackLabel');
        return (
            <Box margin={{ top: "s" }}>
                <Button
                    iconName="download"
                    href={href}
                    target="_blank"
                    ariaLabel={label}
                >
                    {children}
                </Button>
            </Box>
        );
    }
    const safeHref = href && /^https?:\/\//i.test(href) ? href : undefined;
    return (
        <a href={safeHref} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    );
};
